import React, { Component } from "react";
import { EditorState, Modifier, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import CircularProgress from "@material-ui/core/CircularProgress";

import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { encode } from "base-64";
import "../card.css";
import { Button, Icon } from "semantic-ui-react";
import { reactLocalStorage } from "reactjs-localstorage";
import axios from "axios";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import i18n from "../i18n";
import $ from "jquery";
import { RichUtils } from "draft-js";
import PropTypes from "prop-types";
import '../sidemenu.css'
import { API_BASE_URL } from "../utils/endpoints";


class CustomOption extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    editorState: PropTypes.object,
  };

  sendTextToEditor = (text) => {
    const { editorState, onChange } = this.props;

    const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    var html = `${data}${text}`;
    

    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );

      const editorNewState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
      };

      if (editorNewState) {
        onChange(editorNewState);
      }
    }
  };

  closeModal() {
    document.getElementById("modal").style = "display:none";
  }

  handleClickImage(e) {
    const display = document.getElementById("modal").style.display;
    if (display === "none") {
      document.getElementById("modal").style = "display:block";
    } else {
      document.getElementById("modal").style = "display:none";
    }

    document.getElementsByClassName("rdw-image-modal-upload-option").innerHTML =
      document.getElementById("myfile").files.length + " Images Uploaded";
    $(document).ready(function() {
      $('input[type="file"]').change(function(e) {
        var geekss = e.target.files.length;
        $(".rdw-image-modal-upload-option").text(geekss + " file selected.");
      });
    });
  }

  handleClickImage2(e) {
    this.refs.fileUploader.click();
  }

  show = (e) => {
    var token = reactLocalStorage.get("accessToken");

    var imageFiles = document.getElementById("myfile");
    var filesLength = imageFiles.files.length;

    const formData = new FormData();
    for (var i = 0; i < filesLength; i++) {
      formData.append("images", imageFiles.files[i]);
    }

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/general/uploadImage";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/general/uploadImage";
    }

    axios
      .post(apiBaseUrl, formData, {
        headers: { "Content-Type": "multipart/form-data", token: token },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.result != undefined) {
            if (response.data.status === "success") {
              var imagesList = response.data.result.arrayOfImages;
              var length = imagesList.length;
              console.log(imagesList,"imagesList")
              var html = "";
              var newArr = [];
              if (length > 0) {
                for (var i = 0; i < length; i++) {
                  var value = '<img src="' + imagesList[i] + '" />';
                  console.log(value);

                  newArr.push(value);
                }

                var string = newArr.join();

                var string2 = string.replaceAll(",", "<p></p>");

                for (var i = 0; i < newArr.length; i++) {
                  html = `<p></p>${string2}<p></p>`;
                }

              //  this.sendTextToEditor(html.replaceAll("isms", "solutions1"));
                this.sendTextToEditor(html);
                console.log(html,'html')
                this.closeModal();
                ///document.getElementById("rdw-image-modal-upload-option").innerHTML = "Drop Images";
              }
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };

  render() {
    return (
      
    <div>
          <div
            id="modal"
            className="rdw-images-modal"
            style={{ display: "none" }}
          >
            <div style={{ borderBottom: "2px solid #0a66b7" }}>
              Choose Images
            </div>

            <div
              className="rdw-image-modal-upload-option"
              onClick={this.handleClickImage2.bind(this)}
            >
              {" "}
              Drop Images
            </div>
            <input
              type="file"
              id="myfile"
              name="files[]"
              accept=".png, .jpg, .jpeg, .gif ,.svg"
              ref="fileUploader"
              style={{ display: "none" }}
              multiple="multiple"
            />

            <div
              className="rdw-image-modal-btn-section"
              style={{ textAlign: "center" }}
              onClick={() => {
                this.show();
              }}
            >
              <button
                style={{ backgroundColor: "#ece9e9" }}
                className="rdw-image-modal-btn"
              >
                Add
              </button>
              <button
                className="rdw-image-modal-btn"
                onClick={() => {
                  this.closeModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
          <div className="images" onClick={this.handleClickImage.bind(this)}>
            <Icon name="images outline" />
          </div>
        </div>
     
    );
  }
}

////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////

class EditorConvertToHTML extends Component {
  constructor() {
    super();
    this.state = {
      editorState: EditorState.createEmpty(),
      uploadedImages: [],
    };
    
  }
  embedVideoCallBack = (link) => {
    if (link.indexOf("youtube") >= 0) {
      link = link.replace("watch?v=", "embed/");
      link = link.replace("/watch/", "/embed/");
      link = link.replace("youtu.be/", "youtube.com/embed/");
    }
    return link;
  };
  componentDidMount() {
    this.focusEditor();
  }

  setEditor = (editor) => {
    this.editor = editor;
  };

  focusEditor = () => {
    if (this.editor) {
      this.editor.focusEditor();
      console.log("1. Editor has the focus now");
    }
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };


  _uploadImageCallBack(file) {
    let uploadedImages = this.state.uploadedImages;

    const imageObject = {
      file: file,
      localSrc: URL.createObjectURL(file),
    };

    uploadedImages.push(imageObject);

    this.setState({ uploadedImages: uploadedImages });

    return new Promise((resolve, reject) => {
      resolve({ data: { link: imageObject.localSrc } });
    });
  }


pass()
{

  this.props.parentCallback(document.getElementById("area").value)
}
  render() {
    const { editorState } = this.state;
   
    return (
      <>
        
      <div style={{ border: "1px solid gainsboro",minHeight:'500px'}} className="mobigram">
        <Editor
          ref={this.setEditor}
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onEditorStateChange}
          toolbarCustomButtons={[<CustomOption />]}
          toolbar={{
            options: [
              
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              
              "history",
              "list",
              "textAlign",
              
              "link",
              "colorPicker",
              "remove",

             
              
            ],
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true },
            embedded: {
              embedCallback: this.embedVideoCallBack,
            },

            image: {
              className: undefined,
              component: undefined,
              popupClassName: undefined,
              urlEnabled: true,
              uploadEnabled: true,
              alignmentEnabled: true,
              //uploadCallback: this._uploadImageCallBack,
              previewImage: true,
              inputAccept: "image/GIF,image/jpeg,image/jpg,image/png,image/svg",
              alt: { present: false, mandatory: false },
              defaultSize: {
                height: "auto",
                width: "auto",
              },
            },

            emoji: {
              className: undefined,
              component: undefined,
              popupClassName: undefined,
              emojis: [
                "😀",
                "😁",
                "😂",
                "😃",
                "😉",
                "😋",
                "😎",
                "😍",
                "😗",
                "🤗",
                "🤔",
                "😣",
                "😫",
                "😴",
                "😌",
                "🤓",
                "😛",
                "😜",
                "😠",
                "😇",
                "😷",
                "😈",
                "👻",
                "😺",
                "😸",
                "😹",
                "😻",
                "😼",
                "😽",
                "🙀",
                "🙈",
                "🙉",
                "🙊",
                "👼",
                "👮",
                "🕵",
                "💂",
                "👳",
                "🎅",
                "👸",
                "👰",
                "👲",
                "🙍",
                "🙇",
                "🚶",
                "🏃",
                "💃",
                "⛷",
                "🏂",
                "🏌",
                "🏄",
                "🚣",
                "🏊",
                "⛹",
                "🏋",
                "🚴",
                "👫",
                "💪",
                "👈",
                "👉",
                "👉",
                "👆",
                "🖕",
                "👇",
                "🖖",
                "🤘",
                "🖐",
                "👌",
                "👍",
                "👎",
                "✊",
                "👊",
                "👏",
                "🙌",
                "🙏",
                "🐵",
                "🐶",
                "🐇",
                "🐥",
                "🐸",
                "🐌",
                "🐛",
                "🐜",
                "🐝",
                "🍉",
                "🍄",
                "🍔",
                "🍤",
                "🍨",
                "🍪",
                "🎂",
                "🍰",
                "🍾",
                "🍷",
                "🍸",
                "🍺",
                "🌍",
                "🚑",
                "⏰",
                "🌙",
                "🌝",
                "🌞",
                "⭐",
                "🌟",
                "🌠",
                "🌨",
                "🌩",
                "⛄",
                "🔥",
                "🎄",
                "🎈",
                "🎉",
                "🎊",
                "🎁",
                "🎗",
                "🏀",
                "🏈",
                "🎲",
                "🔇",
                "🔈",
                "📣",
                "🔔",
                "🎵",
                "🎷",
                "💰",
                "🖊",
                "📅",
                "✅",
                "❎",
                "💯",
              ],
            },

            colorPicker: {
              className: undefined,
              component: undefined,
              popupClassName: undefined,
              colors: [
                "rgb(97,189,109)",
                "rgb(26,188,156)",
                "rgb(84,172,210)",
                "rgb(44,130,201)",
                "rgb(147,101,184)",
                "rgb(71,85,119)",
                "rgb(204,204,204)",
                "rgb(65,168,95)",
                "rgb(0,168,133)",
                "rgb(61,142,185)",
                "rgb(41,105,176)",
                "rgb(85,57,130)",
                "rgb(40,50,78)",
                "rgb(0,0,0)",
                "rgb(247,218,100)",
                "rgb(251,160,38)",
                "rgb(235,107,86)",
                "rgb(226,80,65)",
                "rgb(163,143,132)",
                "rgb(239,239,239)",
                "rgb(255,255,255)",
                "rgb(250,197,28)",
                "rgb(243,121,52)",
                "rgb(209,72,65)",
                "rgb(184,49,47)",
                "rgb(124,112,107)",
                "rgb(209,213,216)",
                "rgb(192,192,19)",
                "rgb(233,150,122)",
                "rgb(255,160,122)",
                "rgb(135,206,235)",
                "rgb (65,105,225)",
                "rgb(72,61,139)",
                "rgb (238,130,138)",
              ],
            },
          }}
        />
        
     {/* <Button
      floated="right"
      icon
      labelPosition="left"
     style={{marginTop:'10px'}}
      size="small"
      onClick={()=>{this.pass()}}
    >
      <span
        style={{ fontWeight: "bold", color: "black" }}
        id="demo"
      >
        {" "}
        Generate Link
      </span>
      <Icon color="black" name="linkify" color="black" />
    </Button>  */}
   
        <textarea
          disabled={false}
          style={{ width: "100%", height: "100%",display:'none' }}
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
          className="area"
          id="area"
        />
         

       
      </div>
      <Button  color='black'  disabled={this.props.loading}  onClick={()=>{this.pass()}} >
        {this.props.loading==true ?
      <CircularProgress
          size={18}
          style={{ margin: "0px 3px", color: "white" }}
        />

       : <Icon name='linkify'  /> }
        
        Generate Link

        </Button>
              </>
    );
  }
}

export default EditorConvertToHTML;
